import ModalHeader from '../ModalHeader/ModalHeader'
import CustomInput from '../UI/CustomInput/CustomInput'
import CustomTextArea from '../UI/CustomTextArea/CustomTextArea'
import styles from './CreateCommentTemplateModal.module.css'
import { Form, Formik } from 'formik'
import CustomButton from '../UI/CustomButton/CustomButton'
import { CommentTemplateType } from '../../redux/actions/templatesAction'

type CreateCommentTemplateModalProps = {
  onClose: () => void
  onSubmit: (data: { name: string; comment: string; serviceId: number }) => void
  template?: CommentTemplateType | null
  serviceId: number
  serviceName: string
}

const CreateCommentTemplateModal = ({
  onClose,
  onSubmit,
  template,
  serviceId,
  serviceName,
}: CreateCommentTemplateModalProps) => {
  const handleSubmit = (values: { name: string; comment: string }) => {
    onSubmit({
      name: values.name,
      comment: values.comment,
      serviceId,
    })
  }

  return (
    <div className={styles.createCommentTemplate}>
      <div className={styles.titleBlock}>
        <ModalHeader
          title={
            template
              ? `Изменение шаблона для "${serviceName}"`
              : `Создание шаблона для "${serviceName}"`
          }
          onClickHandler={onClose}
        />
      </div>
      <div className={styles.form}>
        <Formik
          enableReinitialize
          initialValues={{
            name: template?.name || '',
            comment: template?.comment || '',
          }}
          onSubmit={handleSubmit}
        >
          {(props) => {
            const { values, handleChange, handleBlur } = props
            return (
              <Form className={styles.commentForm}>
                <div className={styles.formGroupItemInput}>
                  <div className={styles.inputWrapper}>
                    <label className={styles.label}>Название шаблона</label>
                    <CustomInput
                      placeholder='Введите название'
                      name='name'
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                    />
                  </div>
                  <div className={styles.inputWrapper}>
                    <label className={styles.label}>Текст комментария</label>
                    <CustomTextArea
                      withoutFile
                      placeholder='Введите текст'
                      name='comment'
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.comment}
                    />
                  </div>
                </div>
                <div className={styles.footerContainer}>
                  <CustomButton
                    className={styles.submitBtn}
                    title={template ? 'Изменить' : 'Добавить'}
                    disabled={!values.name || !values.comment}
                    type='submit'
                  />
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

export default CreateCommentTemplateModal
